import {
  getHttpConfig,
  getHttpErrorData,
  getHttpHeaders,
  HttpError,
} from '_utils/http';

import {
  TMessageAskHandlers,
  TMessageAskRequest,
  TMessageAskResponse,
} from '_modules/message/types/service';

import { consumeStream } from './sse';

export const askMessage = async (
  data: TMessageAskRequest,
  { onDelta }: TMessageAskHandlers,
): Promise<{ data: TMessageAskResponse }> => {
  const { baseURL } = getHttpConfig();

  const response = await fetch(`${baseURL}chat/ask`, {
    body: JSON.stringify(data),
    headers: { ...getHttpHeaders(), Accept: 'text/event-stream' },
    method: 'POST',
  });

  if (!response.ok || !response.body) {
    throw new HttpError(response.status, await getHttpErrorData(response));
  }

  const conversationId = response.headers.get('X-Conversation-Id');
  const answer = await consumeStream(response.body, onDelta);

  return { data: { answer, conversationId } };
};
